$(document).ready(function() {
    // Checked as initial state...
    if ($('#single_day_event_chk').is(':checked')) {
        $('.form-group').has('#input-date-to').invisible();
    }

    // Events...
    $('.event-add-form, .event-update-form').on('change', '#single_day_event_chk', function () {
        if ($(this).is(':checked')) {
            var date_from = $('#input-date-from').val();
            $('#input-date-to').val(date_from);
            $('.form-group').has('#input-date-to').invisible();
        } else {
            $('.form-group').has('#input-date-to').visible();
        }
    });
    $('.event-add-form, .event-update-form').on('change', '#input-date-from', function () {
        if ($('#single_day_event_chk').is(':checked')) {
            var date_from = $('#input-date-from').val();
            $('#input-date-to').val(date_from);
            $('#input-date-to').removeAttr('required');
        }
    });
});

jQuery.fn.visible = function() {
    return this.css({
        'visibility': 'visible',
        'position': 'static'
    });
};

jQuery.fn.invisible = function() {
    return this.css({
        'visibility': 'hidden',
        'position': 'absolute'
    });
};